import { __extends } from "tslib";
import { Texture } from "../Materials/Textures/texture";
import { PostProcess } from "./postProcess";
import "../Shaders/vrMultiviewToSingleview.fragment";
import "../Engines/Extensions/engine.multiview";
/**
 * VRMultiviewToSingleview used to convert multiview texture arrays to standard textures for scenarios such as webVR
 * This will not be used for webXR as it supports displaying texture arrays directly
 */
var VRMultiviewToSingleviewPostProcess = /** @class */ (function (_super) {
    __extends(VRMultiviewToSingleviewPostProcess, _super);
    /**
     * Initializes a VRMultiviewToSingleview
     * @param name name of the post process
     * @param camera camera to be applied to
     * @param scaleFactor scaling factor to the size of the output texture
     */
    function VRMultiviewToSingleviewPostProcess(name, camera, scaleFactor) {
        var _this = _super.call(this, name, "vrMultiviewToSingleview", ["imageIndex"], ["multiviewSampler"], scaleFactor, camera, Texture.BILINEAR_SAMPLINGMODE) || this;
        _this.onSizeChangedObservable.add(function () {
        });
        _this.onApplyObservable.add(function (effect) {
            if (camera._scene.activeCamera && camera._scene.activeCamera.isLeftCamera) {
                effect.setInt("imageIndex", 0);
            }
            else {
                effect.setInt("imageIndex", 1);
            }
            effect.setTexture("multiviewSampler", camera._multiviewTexture);
        });
        return _this;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "VRMultiviewToSingleviewPostProcess" string
     */
    VRMultiviewToSingleviewPostProcess.prototype.getClassName = function () {
        return "VRMultiviewToSingleviewPostProcess";
    };
    return VRMultiviewToSingleviewPostProcess;
}(PostProcess));
export { VRMultiviewToSingleviewPostProcess };
//# sourceMappingURL=vrMultiviewToSingleviewPostProcess.js.map